"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Inspired by https://github.com/WebDevSimplified/useful-custom-react-hooks/blob/main/src/14-useOnScreen/useOnScreen.js
const react_1 = require("react");
const useOnScreen = (ref, options = { rootMargin: '0px' }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!ref.current) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), options);
        observer.observe(ref.current);
        return () => {
            if (!ref.current) {
                return;
            }
            observer.unobserve(ref.current);
        };
    }, [ref, options]);
    return isVisible;
};
exports.default = useOnScreen;
